// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.5625 1C21.461 1 23 2.53902 23 4.4375V19.5625C23 21.461 21.461 23 19.5625 23H4.4375C2.53902 23 1 21.461 1 19.5625V4.4375C1 2.53902 2.53902 1 4.4375 1H19.5625ZM6.5 13.4561H11.2344L8.44922 20.25L17.5 10.5439H12.7656L15.5508 3.75L6.5 13.4561Z","fillRule":"evenodd","clipRule":"evenodd"}}]};

const LogoStackblitzFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-stackblitz-filled',
    ref,
    icon: element,
  },
));

LogoStackblitzFilledIcon.displayName = 'LogoStackblitzFilledIcon';

export default LogoStackblitzFilledIcon;
